<template>
    <div>
        <div class="">
            <div @click="qr_add" class="saoyisao">
                <Icon type="md-qr-scanner" />
                扫码录系统
            </div>
        </div>
        <div class="tabs_div">
            <Tabs v-model="flow_id" size="small">
                <TabPane label="待面试" name="FLOW_89B19"></TabPane>
            </Tabs>
        </div>
        <div class="daimianshi_box">
            <Spin fix v-if="table_loading"></Spin>
            <div v-for="(item, i)  in resume_list" :key="i" class="resume_card">
                <div class="resume_name">
                    {{ item.name }}
                </div>
                <div class="resume_idcard">
                    <div class="resume_title">
                        身份证号：</div>
                    {{ item.idcard }}
                </div>
                <div class="resume_idcard">
                    <div class="resume_title">
                        手机号：
                    </div>
                    {{ item.phone }}
                </div>
                <div class="create_time">
                    {{ item.create_time }}
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {

    data() {
        return {
            project_id: '',
            page: 1,
            flow_id: "FLOW_89B19",
            resume_list: [],
            table_loading: false

        }
    },

    mounted() {
        var query = this.$route.query
        this.project_id = query.project_id
        console.log(query)
        this.get_daimianshi_list()
    },

    methods: {
        qr_add() {
            console.log('扫码')
            var that = this
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    console.log(result)

                    that.$router.push({
                        'path': '/h5/my_project/scan_detail',
                        query: {
                            resume_id: result,
                            project_id: that.project_id
                        }
                    })
                }
            });
        },


        //获取待面试列表
        get_daimianshi_list() {

            var that = this
            var obj = {
                page: this.page,
                project_id: this.project_id,
                flow_id: this.flow_id,
            }
            that.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.resume_list = res.data.resume_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false


                console.log(res, '请求出错')
            })
        },
    }
}
</script>

<style scoped>
.resume_title{
    width:100px;
    flex-shrink: 0;
}

.create_time {
    display: flex;
    justify-content: flex-end;
    font-size: 10px;
    color: #ccc;
}

.resume_idcard {
    font-size: 12px;
    color: #333;
    display: flex;
    align-items: center;
}

.resume_name {
    font-size: 13px;
    color: #333;
    font-weight: 600;
    margin-bottom: 5px;
}

.tabs_div {
    display: flex;
    padding-left: 10px;
}

.resume_card {
    background-color: #fff;
    padding: 10px;
    border-bottom: 1px solid #f3f3f3;
}

.daimianshi_box {
    min-height: calc(100vh - 100px);
    margin-top: 10px;
    border-top: 1px solid rgb(244, 244, 244);
    position: relative;
}

.saoyisao {
    margin: 10px;
    height: 50px;
    background-color: #0466dd;
    color: #fff;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    border-radius: 5px;
}
</style>